import React from "react";
import {
  background,
  border,
  ChakraProvider,
  color,
  extendTheme,
} from "@chakra-ui/react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
// import { Switch, Route, Redirect } from "react-router-dom";
import { Login } from "../pages/login";
import InvitationPreview from "../pages/invitation/InvitationPreview";
import { PUBLIC_PATHS } from "./constants";
import { PRIMARY_PALETTE } from "../theme/primary";

const authTheme = extendTheme({
  colors: {
    primary: PRIMARY_PALETTE,
    brand: PRIMARY_PALETTE,
    blue: PRIMARY_PALETTE,
    green: PRIMARY_PALETTE,
    cyan: PRIMARY_PALETTE,
    gray: {
      default: "#B5B7C0",
      50: "#F9F9F9",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
  },
  radii: {
    default: "20px",
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    full: "9999px",
  },
  components: {
    Input: {
      variants: {
        outline: {
          field: {
            _focus: {
              borderColor: "primary.500",
              boxShadow: "0 0 0 1px var(--chakra-colors-primary-500)",
            },
            backgroundColor: "gray.100",
            color: "gray.700",
            borderRadius: "20px",
          },
        },
      },
      defaultProps: {
        focusBorderColor: "primary.500",
      },
    },
    Select: {
      variants: {
        outline: {
          field: {
            _focus: {
              borderColor: "primary.500",
              boxShadow: "0 0 0 1px var(--chakra-colors-primary-500)",
            },
            borderColor: "gray.300",
            color: "gray.700",
            borderRadius: "20px",
          },
        },
      },
      defaultProps: {
        focusBorderColor: "primary.500",
      },
    },
    Button: {
      variants: {
        solid: {
          bg: "primary.500",
          color: "white",
          minH: "48px",
          borderRadius: "20px",
          transition: "all 0.2s ease",
          _hover: {
            bg: "primary.700",
            opacity: 0.95,
            transform: "translateY(-1px)",
            _disabled: {
              bg: "primary.500",
            },
          },
          _active: {
            bg: "primary.700",
            transform: "translateY(1px)",
          },
        },
      },
      defaultProps: {
        variant: "solid",
      },
    },
  },
});

// A visitor who is not logged in but landed on a path other than /login —
// e.g. a resident whose session was cleared while away completing a Paystack
// payment, returning to /buy-water?billId=...&reference=... — must not have
// that destination silently discarded. Preserve it as ?next=... so SignIn
// can send them back after authenticating (SignIn already understands this
// param for invitation links; this generalizes it to any protected path).
const RedirectToLogin = ({ login }) => {
  const location = useLocation();
  const next = `${location.pathname}${location.search}`;
  const to = next && next !== "/" ? `${login}?next=${encodeURIComponent(next)}` : login;
  return <Navigate replace to={to} />;
};

export default function UnAuthenticatedApp() {
  const { LOGIN } = PUBLIC_PATHS;
  return (
    <ChakraProvider theme={authTheme}>
      <Routes>
        <Route path={LOGIN} element={<Login />} />
        <Route path="/invitations/:token" element={<InvitationPreview />} />
        <Route path="/*" element={<RedirectToLogin login={LOGIN} />} />
      </Routes>
    </ChakraProvider>
  );
}
